import React from "react";
import Permissions from "../../configs/permissions";
import usePermissions from "../../hooks/permissions";
import VabooUserInvoiceCreate from "./VabooUserInvoiceCreate";

const TenantInvoiceCreate = () => {
  const { protectPage } = usePermissions();
  protectPage(Permissions.Mutation.CreateUserInvoice);
  return <VabooUserInvoiceCreate />;
};

export default TenantInvoiceCreate;
